<template>
  <div class="site-action">
    <search class="site-action__item" />
    <a class="site-action__item" href="http://www.kamgov.ru/site-map">
      <icon name="map" width="30" height="23" />
    </a>
    <a class="site-action__item" href="https://www.instagram.com/kamgov_41">
      <icon  name="instagram" width="22" height="22" />
    </a>
    <a class="site-action__item site-action__item--login" href="https://kamgov.ru/user-esia/login?redirect=%2F">
      <icon name="login" width="27" height="22" />
    </a>
  </div>
</template>

<script>
import Icon from '../shared/Icon'
import Search from './Search'

export default {
  components: {
    Icon,
    Search
  }
}
</script>

<style lang="scss" scoped>
.site-action {
  display: flex;
  width: 100%;

  &__item {
    cursor: pointer;
    display: inline-block;

    & + &:not(.site-action__item--login) {
      margin-left: 25px;
    }

    &--login {
      margin-left: auto;
    }
  }
}
</style>
